import Api from './Api'

export default {
    async show(parameters) {
        const api = await Api()
        return api.post('servers', parameters)
    },
    async login(parameters) {
        const api = await Api()
        return api.post('server/login', parameters)
    },
    async saveLocal(parameters) {
        const api = await Api()
        return api.post('server/save-local', parameters)
    },
    async clearCredentials(parameters) {
        const api = await Api()
        return api.post('server/clear-credentials', parameters)
    },
    async saveCloud(parameters) {
        const api = await Api()
        return api.post('server/save-cloud', parameters)
    },
    async setServerType(parameters) {
        const api = await Api()
        return api.post('server/type', parameters)
    },
}